import React, { createContext, useContext } from 'react';

export interface TableSelectionContextValue {
  hasSelection: boolean;
  canMerge: boolean;
  mergeCells: () => void;
  deleteSelectedRows: () => void;
  deleteSelectedColumns: () => void;
  insertRowUp: () => void;
  insertRowDown: () => void;
  insertColumnLeft: () => void;
  insertColumnRight: () => void;
}

const TableSelectionContext = createContext<TableSelectionContextValue>({
  hasSelection: false,
  canMerge: false,
  mergeCells: () => {},
  deleteSelectedRows: () => {},
  deleteSelectedColumns: () => {},
  insertRowUp: () => {},
  insertRowDown: () => {},
  insertColumnLeft: () => {},
  insertColumnRight: () => {},
});

export const useTableSelection = () => useContext(TableSelectionContext);

export const TableSelectionProvider = TableSelectionContext.Provider;
